import React, { useEffect, useState } from "react";

// redux
import { useSelector } from "react-redux";
import { selectUsedTheme } from '_redux/slices/timeline/theme';

const TimelineContentContainer = (props) => {

  const usedTheme = useSelector(selectUsedTheme);


  const scrollbarStyles = {
    display: "flex",
    overflowX: 'scroll',
    overflowY: 'scroll',
    scrollbarWidth: 'thin',
    scrollbarColor: usedTheme.BACKGROUND_COLOR,
    '&::-webkit-scrollbar': {
      width: '12px',
      height: '12px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'red',
      borderRadius: '10px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'green',
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: 'yellow'
      }
    }
  };


  return (
    <div
      ref={props.devRef}
      onScroll={props.onDevScroll}
      style={{
        display: "flex",
        overflowX: 'scroll',
        overflowY: 'scroll',
        // borderStyle: 'solid', borderWidth: 3, borderColor: 'red',
        // height: props.maxHeight,
        //width: '100%',
        ...scrollbarStyles
      }}
    >
      <div>{props.children}</div>
    </div>
  );
};

export default TimelineContentContainer;
